import React from "react";
import { useLocation } from "react-router-dom";

export function withLocation(Component: any) {
  return (props: any) => (<Component locationHooks={useLocation()} {...props}/>);
}
